// Libraries
import PhoneInput from "react-phone-input-2";
import clsx from "clsx";

// CSS
import "react-phone-input-2/lib/style.css";

// Types
import { ChangeEvent } from "react";
import { CountryData } from "react-phone-input-2";

type TPhoneNumberInputProps = {
	defaultValue?: string;
	value: string;
	placeholder: string;
	className?: string;
	error: boolean;
	disabled: boolean;
	onChange: (value: string, data: {} | CountryData, event: ChangeEvent<HTMLInputElement>) => void;
};

export function PhoneNumberInput(props: Readonly<TPhoneNumberInputProps>) {
	const { value, placeholder, defaultValue = "us", className = "", error = false, disabled, onChange } = props;

	return (
		<PhoneInput
			country={defaultValue}
			onBlur={(e, data) => onChange(value, data, e)}
			placeholder={placeholder}
			containerClass=""
			inputClass={clsx({
				"!w-full !h-[30px] rounded-md p-[10px] !pl-[55px] font-regular-sans text-sm  mt-[14px] !text-default ": true,
				"border-disabled": !error,
				[`!shadow-thin-red-line !bg-light-error !border-[0px]`]: error,
				[`${className}`]: Boolean(className),
			})}
			buttonClass={clsx({
				"rounded-none rounded-t-[6px] rounded-b-[6px] !border-r-[0]": true,
				"!border-[red] !bg-light-error [&>.selected-flag]:!bg-light-error": error,
				"!border-disable !bg-white [&>.selected-flag]:!bg-white": !error,
				"[&>.selected-flag>.flag>.arrow]:!bg-[url(@/assets/icons/svg/chevron-down.svg)]": true,
				"[&>.selected-flag>.flag>.arrow.up]:!bg-[url(@/assets/icons/svg/chevron-up.svg)]": true,
				"[&>.selected-flag>.flag>.arrow]:!w-[15px]": true,
				"[&>.selected-flag>.flag>.arrow]:!h-2": true,
				"[&>.selected-flag>.flag>.arrow]:!border-none": true,
				"[&>.selected-flag>.flag>.arrow]:!top-[4px]": true,
				"[&>.selected-flag>.flag>.arrow]:!mx-[4px]": true,
			})}
			searchClass=""
			containerStyle={{}}
			dropdownStyle={{
				borderRadius: "6px",
				boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
				fontFamily: "PTSansPro",
				fontSize: "14px",
				color: "var(--default-text-color)",
				marginTop: "2px",
				height: "300px",
			}}
			value={value}
			disabled={disabled}
		/>
	);
}
